<template>
  <div class="top">
    <!-- <img src="@/assets/home-back.png" ref="imgRef" /> -->
    <div class="content">
      <div class="left">
        <div class="left-top">
          <img :src="topText" alt class="img1" />
          <div>
            <img :src="top1" alt class="img2" />
            <img :src="top2" alt class="img3" />
          </div>
        </div>
        <p>基于星火 · 链网的数智双碳平台</p>
        <img :src="line" class="img" />
      </div>
      <!-- <div class="rigth" @click="GET_ISSHOW(true)">申请试用</div> -->
    </div>
    <!-- <div class="page">
      <div class="left">
        <span>1</span>
        <span>/3</span>
      </div>
      <div class="right">
        <img src="@/assets/left.png" alt @click="toggle(1)" />
        <img src="@/assets/right.png" alt @click="toggle(2)" />
      </div>
    </div>-->
  </div>
</template>

<script>
import top1 from "@/assets/home/top1.png";
import top2 from "@/assets/home/top2.png";
import topText from "@/assets/home/top-text.png";
import line from "@/assets/home/line.png";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      top1: top1,
      top2: top2,
      topText: topText,
      line: line
    };
  },
  // mounted() {
  //   // 获取图片元素
  //   const img = this.$refs.imgRef;
  //   // 计算相对宽度
  //   const relativeWidth = (img.clientWidth / window.innerWidth) * 100;
  //   // 计算vw值
  //   const vw = (img.clientWidth / relativeWidth).toFixed(2);
  //   if (window.innerWidth > 1400) {
  //     img.style.transform = `translateX(-50%) scale(${0.99})`;
  //   }
  // },
  methods: {
    ...mapMutations(["GET_ISSHOW"]),
    toggle(type) {
      if (type == 1) {
        console.log("++");
      } else {
        console.log("--");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  box-sizing: border-box;
  padding-top: 158px;
  position: relative;
  background-image: url("@/assets/home-back.png");
  z-index: -888;
  min-height: 600px;
  background-size: cover;
  > img {
    position: absolute;
    width: 1903px;
    height: 600px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: -999;
  }
  .page {
    position: absolute;
    left: 50%;
    transform: translateX(-455px);
    bottom: 73px;
    display: flex;
    .left {
      margin-right: 21px;
      span {
        font-size: 24px;
        font-family: D-DIN-PRO-Medium, D-DIN-PRO;
        font-weight: bold;
        color: #ffffff;
        line-height: 29px;
        margin-right: 4px;
      }
      span:nth-child(2) {
        color: #00dd62;
        margin-right: 0px;
      }
    }
    .right {
      img:nth-child(1) {
        margin-right: 14px;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .content {
    width: 911px;
    height: 207px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      flex-direction: column;

      .left-top {
        display: flex;

        .img1 {
          width: 260px;
          height: 82px;
          margin-right: 13px;
        }

        > div {
          display: flex;
          flex-direction: column;

          .img2 {
            width: 152px;
            height: 51px;
          }

          .img3 {
            width: 190px;
            height: 18px;
          }
        }
      }

      > p {
        margin-top: 35px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 33px;
      }

      > img {
        width: 40px;
        height: 6px;
        margin-top: 48px;
      }
    }

    .rigth {
      width: 162px;
      height: 50px;
      background-image: url("@/assets/home/rectangle.png");
      background-size: 100%;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
</style>